// Belt-and-suspenders signal that the onboarding wizard finished, written when
// the wizard's last step → finishWizard fires. We trust this flag as a fallback so a
// stale auth-store user (where /auth/me hasn't refetched onboardedAt yet)
// doesn't re-bounce the user back into /onboarding from the auth callback or a
// 404 → back-button journey. The server-side onboarded_at is still the source
// of truth — this just covers the brief client-side window between PATCH
// success and store rehydration, and the legacy-user case where onboarded_at
// was never persisted.

const COMPLETED_WIZARD_KEY = 'onboarding.completedWizard';

export function readCompletedWizardFlag(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(COMPLETED_WIZARD_KEY) === '1';
  } catch {
    return false;
  }
}

export function markWizardCompleted(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(COMPLETED_WIZARD_KEY, '1');
  } catch {
    // localStorage may be unavailable in private mode — non-fatal; the
    // server's onboarded_at remains the source of truth.
  }
}

export function isOnboarded(
  user: { onboardedAt?: string | null; platformRole?: string | null } | null | undefined,
): boolean {
  // Platform admins never take the customer wizard. ProtectedRoute already
  // exempts them from its /onboarding redirect; the post-login navigations
  // (email-OTP verify + OAuth callback) route through here and must agree,
  // otherwise an admin whose profile has onboarded_at=null is funneled into
  // the wizard on every sign-in.
  if (user?.platformRole === 'platform_admin') return true;
  return !!user?.onboardedAt || readCompletedWizardFlag();
}
